import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StaffCard.css";

class Account extends Component {
  render() {
    const { classes, staff } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>Account's Information</h3>
          {staff.panNumber && (
            <ListItem divider>
              <div style={{ flexGrow: 1 }}>PAN Number</div>
              <div>{staff.panNumber}</div>
            </ListItem>
          )}
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Citizenship Number</div>
            <div>{staff.citizenshipId}</div>
          </ListItem>
          {staff.bankDetails && (
            <Fragment>
              <ListItem divider>
                <div style={{ flexGrow: 1 }}>Account Number</div>
                <div>{staff.bankDetails.accountNumber}</div>
              </ListItem>
              <ListItem divider>
                <div style={{ flexGrow: 1 }}>Bank Name</div>
                <div>{staff.bankDetails.bankName}</div>
              </ListItem>
              <ListItem divider>
                <div style={{ flexGrow: 1 }}>Branch Address</div>
                <div>{staff.bankDetails.branchName}</div>
              </ListItem>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Account);
